import { createTheme } from '@mui/material/styles';

const black = '#000';
export const primaryColor = '#6414db';
const defaultColor = '#C7C6C6';
const borderColorDefault = '#000';
const white = '#fff';
const errorColor = '#d32f2f';

const inputHeight = '37px';
const inputPaddingHorizontal = '0.75rem';

const labelInputText = {
  fontSize: '1.0625rem',
  lineHeight: '1.25rem',
};

const themeBasic = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
    info: {
      main: defaultColor,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 992,
      lg: 1400,
      xl: 1536,
    },
  },
});

export { themeBasic };
